(function () {
  try {
    function applySalepifyCurrencyFix(instance) {
      if (!instance || instance._currencyFixApplied) return;

      var originalFormatMoney = instance.formatMoney;
      if (typeof originalFormatMoney !== 'function') return;

      instance.formatMoney = function (
        t,
        currencyFormat,
        currencyDisplay
      ) {
        try {
          var currencyCode = this.currency || 'ZAR';
          var parsedDisplay = currencyDisplay;

          if (typeof parsedDisplay === 'string') {
            try {
              parsedDisplay = JSON.parse(parsedDisplay);
            } catch (err) {
              parsedDisplay = {};
            }
          }

          var hasDisplay =
            parsedDisplay &&
            typeof parsedDisplay === 'object' &&
            parsedDisplay[currencyCode] &&
            parsedDisplay[currencyCode].display_format;

          var activeDisplay = hasDisplay
            ? parsedDisplay
            : {
                [currencyCode]: {
                  display_format: 'R {{amount}}'
                }
              };

          return originalFormatMoney.call(
            this,
            t,
            currencyFormat,
            activeDisplay
          );
        } catch (err) {
          return originalFormatMoney.apply(this, arguments);
        }
      };

      instance._currencyFixApplied = true;

      if (typeof instance.updateAllCartGoals === 'function') {
        instance.updateAllCartGoals();
      }
    }

    function applySalepifyGiftModalFix(instance) {
      if (!instance || instance._giftModalFixApplied) return;

      var originalToggleGifts = instance.toggleGifts;
      if (typeof originalToggleGifts !== 'function') return;

      instance.toggleGifts = function (
        cartGoalIndex,
        giftMilestoneIndex,
        isOpen
      ) {
        try {
          if (isOpen === false) {
            return originalToggleGifts.apply(
              instance,
              arguments
            );
          }

          var modal = document.querySelector(
            '.tl__cart-goal__gift-modal-' +
            cartGoalIndex +
            '-' +
            giftMilestoneIndex
          );

          if (!modal) {
            return originalToggleGifts.apply(
              instance,
              arguments
            );
          }

          instance.renderSelectedGift(
            giftMilestoneIndex,
            cartGoalIndex
          );

          // Dùng show() để giữ cart drawer mở.
          if (!modal.open) {
            modal.show();
          }

          instance.getQuantitySelected(
            giftMilestoneIndex
          );
        } catch (err) {
          return originalToggleGifts.apply(
            instance,
            arguments
          );
        }
      };

      instance._giftModalFixApplied = true;
    }

    function applySalepifyFixes(instance) {
      applySalepifyCurrencyFix(instance);
      applySalepifyGiftModalFix(instance);
    }

    if (window.tlCartGoalEmbed) {
      applySalepifyFixes(window.tlCartGoalEmbed);
    } else {
      var checkCount = 0;

      var checkTimer = setInterval(function () {
        checkCount++;

        if (window.tlCartGoalEmbed) {
          applySalepifyFixes(window.tlCartGoalEmbed);
          clearInterval(checkTimer);
        }

        if (checkCount > 50) {
          clearInterval(checkTimer);
        }
      }, 100);
    }
  } catch (e) {}
})();